import React from "react";

function ViewSubCategory({ data }) {
  const formatDateTime = (date) => {
    if (!date) return "-";

    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };

  return (
<div className="modal-form-wrapper">
  <div className="row">

    <div className="col-md-6 mb-2">
      <label>Sub Category Name</label>
      <input
        type="text"
        className="form-control"
        value={data?.name || "-"}
        readOnly
      />
    </div>

    <div className="col-md-6 mb-2">
      <label>Category Name</label>
      <input
        type="text"
        className="form-control"
        value={data?.category_details?.name || "-"}
        readOnly
      />
    </div>

    <div className="col-md-6 mb-2">
      <label>Category Slug</label>
      <input
        type="text"
        className="form-control"
        value={data?.category_details?.slug || "-"}
        readOnly
      />
    </div>

    <div className="col-md-6 mb-2">
      <label>Status</label>
      <input
        type="text"
        className="form-control"
        value={data?.status === 1 ? "Active" : "Inactive"}
        readOnly
      />
    </div>

    <div className="col-md-6 mb-2">
      <label>Created At</label>
      <input
        type="text"
        className="form-control"
        value={formatDateTime(data?.created_at)}
        readOnly
      />
    </div>

    <div className="col-md-6 mb-2">
      <label>Updated At</label>
      <input
        type="text"
        className="form-control"
        value={formatDateTime(data?.updated_at)}
        readOnly
      />
    </div>

  </div>
</div>

  );
}

export default ViewSubCategory;